import type {RootState} from "../../redux/types";

export const selectedLangSelector = (state: RootState) => state.i18n.selectedLang;